namespace ui
{
	export namespace fab
	{

		/**
		 * orientation: 'left'|'up'|'right'|'down'; default: 'down'
		 * position: {top:string, bottom:string, left:string, right:string}; default: {top:'0px',left:'0px'}
		 * absolute: boolean; default: false
		 */
		export interface IFABListOptions extends ui.base.IBaseHTMLElementDescriptor
		{
			orientation?:	'left'|'up'|'right'|'down';
			position?:
			{
				top?:				string;
				bottom?:		string;
				left?:			string;
				right?:			string;
			};
			absolute?:		boolean;
		}

		function PreprocessOptions( options: IFABListOptions ): IFABListOptions
		{
			if ( !options.orientation )
			{
				options.orientation	= 'down';
			}
			if ( options.absolute === undefined )
			{
				options.absolute		= false;
			}
			if ( !options.position )
			{
				options.position		= { top: '0px', left: '0px' };
			}

			if ( !options.position.top && !options.position.bottom )
			{
				options.position.top	= '0px';
			}
			if ( !options.position.left && !options.position.right )
			{
				options.position.left	= '0px';
			}

			return options;
		}

		export class FABList
			extends ui.base.HTMLPresentation
		{

			public readonly	Descriptor:	IFABListOptions;

			private		m_List:			ui.base.Button[];

			public constructor( options?: IFABListOptions )
			{
				super( 'fab-list' );

				this.Descriptor	= PreprocessOptions( options || {} );

				this.m_List			= new Array();
			}

			public Initialize(): FABList
			{
				super.Initialize( this.Descriptor );

				if ( this.Descriptor.absolute )
				{
					this.css( 'position', 'absolute' );
				}

				if ( this.Descriptor.orientation )
				{
					switch ( this.Descriptor.orientation )
					{
						case 'left':	this.addClass( 'horizontal reverse' );	break;
						case 'right':	this.addClass( 'horizontal' );					break;
						case 'up':		this.addClass( 'reverse' );							break;

						default: break;
					}
				}

				if ( this.Descriptor.position )
				{
					if ( this.Descriptor.position.top !== undefined )
					{
						this.css( 'top', this.Descriptor.position.top + 'px' );
					}

					if ( this.Descriptor.position.left !== undefined )
					{
						this.css( 'left', this.Descriptor.position.left + 'px' );
					}

					if ( this.Descriptor.position.right !== undefined )
					{
						this.css( 'right', this.Descriptor.position.right + 'px' );
					}

					if ( this.Descriptor.position.bottom !== undefined )
					{
						this.css( 'bottom', this.Descriptor.position.bottom + 'px' );
					}
				}

				return this;
			}

			public add( item: ui.base.Button ): FABList
			{
				this.m_List.push( item );

				item.css( 'position', '' );

				return this;
			}

			public rebuild( root: JQuery|ui.base.BaseHTMLElement ): FABList
			{
				super.rebuild( root );

				this.Initialize();

				this.empty();

				this.m_List.forEach( ( element ) => element.appendTo( this ) );

				return this;
			}

		}

	}
}
